import { ITable } from './table'
import { IChartPoint, IFile, IIssue, IMaxThreads, IStatus, IStorage, ITemperature } from './types'

export const ADD_FILE = 'ADD_FILE'
export type AddFileType = 'ADD_FILE'
export interface IAddFileAction { data: { file: IFile }, type: AddFileType }
export const addFile = (file: IFile): IAddFileAction => ({ data: { file }, type: ADD_FILE, })

export const ADD_ISSUE = 'ADD_ISSUE'
export type AddIssueType = 'ADD_ISSUE'
export interface IAddIssueAction { data: { issues: IIssue[] }, type: AddIssueType }
export const addIssues = (issues: IIssue[]): IAddIssueAction => ({ data: { issues }, type: ADD_ISSUE, })

export const OPEN_FILE = 'OPEN_FILE'
export type OpenFileType = 'OPEN_FILE'
export interface IOpenFileAction { data: { id: number }, type: OpenFileType }
export const openFile = (id: number): IOpenFileAction => ({ data: { id }, type: OPEN_FILE, })

export const RESET_STORE = 'RESET_STORE'
export type ResetStoreType = 'RESET_STORE'
export interface IResetStoreAction { type: ResetStoreType }
export const resetStore = (): IResetStoreAction => ({ type: RESET_STORE })

export const SET_ZIP_NAME = 'SET_ZIP_NAME'
export type SetZipNameType = 'SET_ZIP_NAME'
export interface ISetZipNameAction { type: SetZipNameType, data: { zipName: string } }
export const setZipName = (zipName: string): ISetZipNameAction => ({ type: SET_ZIP_NAME, data: { zipName } })

export const SET_HARDWARE_VARIANT = 'SET_HARDWARE_VARIANT'
export type SetHardwareVariantType = 'SET_HARDWARE_VARIANT'
export interface ISetHardwareVariantAction { type: SetHardwareVariantType, data: { hardwareVariant: string } }
export const setHardwareVariant = (hardwareVariant: string): ISetHardwareVariantAction =>
  ({ type: SET_HARDWARE_VARIANT, data: { hardwareVariant }})

export const SET_MAX_TEMP = 'SET_MAX_TEMP'
export type SetMaxTempType = 'SET_MAX_TEMP'
export interface ISetMaxTempAction { type: SetMaxTempType, data: { temperature: ITemperature } }
export const setMaxTemp = (temperature: ITemperature): ISetMaxTempAction =>
  ({ type: SET_MAX_TEMP, data: { temperature }})

export const SET_MAX_THREADS = 'SET_MAX_THREADS'
export type SetMaxThreadsType = 'SET_MAX_THREADS'
export interface ISetMaxThreadsAction { type: SetMaxThreadsType, data: { maxThreads: IMaxThreads } }
export const setMaxThreads = (maxThreads: IMaxThreads): ISetMaxThreadsAction =>
  ({ type: SET_MAX_THREADS, data: { maxThreads }})

export const SET_SOLSTICE_VERSION = 'SET_SOLSTICE_VERSION'
export type SetSolsticeVersionType = 'SET_SOLSTICE_VERSION'
export interface ISetSolsticeVersionAction { type: SetSolsticeVersionType, data: { version: string, buildNumber: string } }
export const setSolsticeVersion = (version: string, buildNumber: string): ISetSolsticeVersionAction =>
  ({ type: SET_SOLSTICE_VERSION, data: { version, buildNumber, } })

export const SET_STORAGE = 'SET_STORAGE'
export type SetStorageType = 'SET_STORAGE'
export interface ISetStorageAction { type: SetStorageType, data: { storage: IStorage } }
export const setStorage = (storage: IStorage ): ISetStorageAction => ({ type: SET_STORAGE, data: { storage } })

export const ADD_CHART_POINT = 'ADD_CHART_POINT'
export type AddChartPointType =  'ADD_CHART_POINT'
export interface IAddChartPointAction { type: AddChartPointType, data: { chartPoint: IChartPoint }}
export const addChartPoint = (chartPoint: IChartPoint): IAddChartPointAction => ({ type: ADD_CHART_POINT, data: { chartPoint }})

export const SET_STATUS = 'SET_STATUS'
export type SetStatusType = 'SET_STATUS'
export interface ISetStatusAction { type: SetStatusType, data: { status: IStatus } }
export const setStatus = (status: IStatus ): ISetStatusAction => ({ type: SET_STATUS, data: { status } })

export const SAVE_DATA_STORE = 'SAVE_DATA_STORE'
export type SaveDataStoreType = 'SAVE_DATA_STORE'
export interface ISaveDataStoreAction { type: SaveDataStoreType, data: { datastore: ITable } }
export const saveDataStore = (datastore: ITable): ISaveDataStoreAction => ({ type: SAVE_DATA_STORE, data: { datastore }})

export const SET_CURRENT_TAB = 'SET_CURRENT_TAB'
export type SetCurrentTabType = 'SET_CURRENT_TAB'
export interface ISetCurrentTabAction { type: SetCurrentTabType, data: { currentTab: number } }
export const setCurrentTab = (currentTab: number): ISetCurrentTabAction => ({ type: SET_CURRENT_TAB, data: { currentTab }})



// WEBPACK FOOTER //
// ./src/actions.ts